module.exports = __webpack_public_path__ + "img/headImg.6ee86f13.png";